import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

/** Link component for navigation */

const LinkTo = styled(NavLink)`
  &&& {
    text-decoration: none;
    margin-bottom: 0;
    color: ${(props) =>
      (props.theme && props.theme.color && props.theme.color.link) ?? "auto"};
  }

  div {
    margin-top: ${(props) =>
      (props.theme && props.theme.spacing && props.theme.spacing.s2) ?? "0"};
    margin-bottom: 0;
  }

  &&&:hover {
    text-decoration: underline;
  }

  span,
  a {
    color: ${(props) =>
      (props.theme && props.theme.color && props.theme.color.link) ?? "auto"};
    font-size: ${(props) =>
      (props.theme && props.theme.font && props.theme.font.size.small) ??
      "auto"};
    font-weight: ${(props) =>
      (props.theme && props.theme.font && props.theme.font.weight.bold) ??
      "auto"};
    font-family: ${(props) =>
      (props.theme &&
        props.theme.font &&
        props.theme.font.family &&
        props.theme.font.family.link) ??
      "auto"};
    line-height: ${(props) =>
      (props.theme && props.theme.spacing && props.theme.spacing.m2) ?? "0"};
  }

  span:hover {
    color: #2a6496;
  }
`;

export default LinkTo;
